exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spinner {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .loading-spinner {\n    width: 50px;\n    height: 50px;\n    border: 10px solid #f3f3f3; /* Light grey */\n    border-top: 10px solid #383636; /* Black */\n    border-radius: 50%;\n    animation: spinner 1.5s linear infinite;\n  }\n\n  .spinner-container {\n    display: grid;\n    justify-content: center;\n    align-items: center;\n    height: 350px;\n  }", ""]);

// exports
